import { render } from "./publish_header.vue?vue&type=template&id=0e461254"
import script from "./publish_header.vue?vue&type=script&lang=js"
export * from "./publish_header.vue?vue&type=script&lang=js"

import "./publish_header.vue?vue&type=style&index=0&id=0e461254&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__